import { Stack, Typography, useTheme } from "@mui/material";
import React, { useState } from "react";
import FilterListIcon from "@mui/icons-material/FilterList";
import { GradientBorderBox } from "../../../../Components";
export default function TopBar({ query, handleQuery }) {
  const theme = useTheme();
  // const [selected, setSelected] = useState(null);

  const filters = [
    { label: "ارزان ترین", value: "cheapest" },
    { label: "گران ترین", value: "expensive" },
    // { label: "مرتبط ترین", value: "filter3" },
    { label: "جدید ترین", value: "newest" },
    { label: "پربازدید ترین", value: "visited" },
    { label: "پرفروش ترین", value: "best_seller" },
  ];
  const items = filters?.map((e, index) => {
    return (
      <Stack
        key={index}
        sx={{
          transform: query.sortType == e?.value ? "scale(1.02)" : "",
          transition: "all .2s",
          color: theme.palette.primary.main,
          bgcolor: theme.palette.background.cream,
          borderRadius: "6px",
          alignItems: "center",
          border: `1px solid ${
            query.sortType == e?.value
              ? theme.palette.primary.main
              : "transparent"
          }`,
          padding: "0.5rem 1rem",
          cursor: "pointer",
          position: "relative",
        }}
        onClick={() =>
          handleQuery("sortType", query.sortType == e?.value ? "" : e?.value)
        }
      >
        <Typography sx={{ whiteSpace: "nowrap" }}>{e?.label}</Typography>
        {query?.sortType == e?.value ? null : (
          <GradientBorderBox
            bgGrad={`linear-gradient(
            90deg,
            ${theme.palette.background.paper} -30%,
            ${theme.palette.background.default} 50%,
            ${theme.palette.background.paper} 130%
          )`}
            radius=".3rem"
          />
        )}
      </Stack>
    );
  });
  return (
    <Stack sx={{ gap: "1rem", alignItems: "center" }} direction={"row"}>
      <Stack
        direction={"row"}
        sx={{
          color: theme.palette.primary.main,
          borderRadius: "6px",
          padding: "0.5rem 1rem",
          alignItems: "center",
          gap: ".2rem",
        }}
      >
        <FilterListIcon sx={{ fontSize: "2.1rem", fontWeight: "bold" }} />
        <Typography
          sx={{ whiteSpace: "nowrap", fontSize: "1.1rem", fontWeight: "bold" }}
        >
          مرتب سازی
        </Typography>
      </Stack>
      {items}
    </Stack>
  );
}
